export type GetLeaderboardResultsParams = {
  athlinksEventId?: number
  eventCourseId?: number
  divisionId?: number
  intervalId?: number
}

export const getLeaderboardResultsPath = ({
  athlinksEventId,
  eventCourseId,
  divisionId,
  intervalId,
}: GetLeaderboardResultsParams) =>
  athlinksEventId
    ? eventCourseId
      ? divisionId
        ? intervalId
          ? `event/${athlinksEventId}/race/${eventCourseId}/division/${divisionId}/interval/${intervalId}`
          : `event/${athlinksEventId}/race/${eventCourseId}/division/${divisionId}`
        : `event/${athlinksEventId}/race/${eventCourseId}`
      : `event/${athlinksEventId}`
    : ''
